<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button
        class="btn btn-primary wizard-btn next-btn"
        @click="nextStep"
        :disabled="!model.dateRange.from || !model.dateRange.to || !model.title"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="row mb-4 mt-3">
      <div class="col-md-6 mb-3">
        <div v-if="isExternalClient" class="card custom-card mb-7">
          <div class="card-body">
            <div class="py-2 px-3 custom-card">
              <h5>{{ $t("minibus.request.step.two.personal.info") }}</h5>
              <d-form-row>
                  <!-- First Name -->
                  <d-col md="6" class="form-group">
                    <label for="firstName">{{ $t("user.firstname") }}</label>
                    <d-input
                      type="text"
                      id="firstName"
                      v-model="model.firstName"
                      :state="errors['firstName'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="firstName" />
                  </d-col>
                  <!-- Last Name -->
                  <d-col md="6" class="form-group">
                    <label for="lastName">{{ $t("user.lastname") }}</label>
                    <d-input
                      type="text"
                      id="lastName"
                      v-model="model.lastName"
                      :state="errors['lastName'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="lastName" />
                  </d-col>
                  <!-- Email Address -->
                  <d-col md="6" class="form-group" id="stepTwo-from-group_3">
                    <label for="emailAddress">{{ $t("user.email") }}</label>
                      <d-input
                        id="emailAddress"
                        type="email"
                        v-model="model.email"
                        :state="errors['email'] === undefined ? null : false"
                      />
                    <errors :errors="errors" field="email" />
                  </d-col>
              </d-form-row>
            </div>
          </div>
        </div>
        <div class="card custom-card">
            <div class="card-body">
                <div class="py-2 px-3 custom-card">
                    <h5>{{ $t("minibus.request.step.two.reason") }}</h5>
                    <d-form-row>
                        <!-- title -->
                        <d-col md="6" class="form-group">
                            <h6>{{ $t("minibus.request.step.two.reason.title") }}
                              <sup class="text-red">*</sup>
                            </h6>
                            <d-input
                            type="text"
                            id="title"
                            v-model="model.title"
                            :state="errors['title'] === undefined ? null : false"
                            />
                            <errors :errors="errors" field="title" />
                        </d-col>
                    </d-form-row>
                            <h6>
                            {{ $t("minibus.request.step.two.reason.discription") }}
                            </h6>
                            <textarea
                            v-model="model.description"
                            class="form-control col-md-12"
                            cols="30"
                            rows="7"
                            :placeholder="$t('minibus.request.step.two.reason.discription.placeholder')"
                            ></textarea>
                </div>
            </div>
      </div>
      </div>
      <div class="col-md-6 marginBottom">
        <div class="card custom-card">
          <div class="card-body">
              <h5 class="px-5 pt-4">{{ $t("minibus.request.step.two.reason.trip.information") }}</h5>
              <div class="mt-1 d-flex flex-column">
                <div class="row backgroundRow py-2 px-5">
                  <!-- Destination -->
                  <d-col md="12" class="form-group">
                    <label for="destination">{{ $t("minibus.request.step.two.destination") }}</label>
                    <d-input
                      type="text"
                      id="destination"
                      v-model="model.destination"
                      :state="errors['destination'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="destination" />
                  </d-col>
                </div>
                <div class="row backgroundRow py-2 px-5">
                  <div class="py-5 d-flex flex-column fullWidth">
                    <div class="row pt-5 d-flex flex-row align-items-center">
                      <h6 class="mx-3">{{ $t("minibus.request.step.two.starting.date")}}</h6>
                      <p class="minibus-request-step2-date-slot"> {{dateFrom}}</p>
                    </div>
                    <div class="row">
                      <div class="col-12 col-lg-6 jjj px-4">
                        <label for="datepicker">{{ $t("minibus.request.step.two.starting.date.date") }}<sup class="text-red">*</sup></label>
                        <d-datepicker
                          id="datepicker"
                          class="pr-1"
                          v-model="model.dateRange.from"
                          :disabledDates="disabledDatesFrom"
                          placeholder="Date de debut"
                          @input="checkDates"
                          :input-class="['form-control', 'datepicker', 'py-3']"
                          :language="fr"
                          small
                        ></d-datepicker>
                      </div>
                      <div class="col-12 col-lg-6 jjj px-4 d-flex align-items-center">
                        <div>
                          <label>{{ $t("global.select.starting.time") }}</label>
                          <div class="row pl-3 pt-2">
                            <div class="d-flex align-items-center justify-content-center">
                              <select
                                id="hourStart"
                                class="form-control mt-0"
                                v-model="model.startHour"
                                @change="changeEndHour"
                                :disabled="disabled"
                              >
                                <option v-for="(h, idx) in hours" :key="idx" :value="h">
                                  {{ h }}
                                </option>
                              </select>
                              <label class="text-label mx-2 mb-0">H:</label>
                            </div>

                            <div class="d-flex align-items-center justify-content-center">
                              <select
                                id="minuteStart"
                                class="form-control mt-0"
                                v-model="model.startMinute"
                                @change="$emit('updateDate', model)"
                                :disabled="disabled"
                              >
                                <option v-for="(m, idx) in minutes" :key="idx" :value="m">
                                  {{ m }}
                                </option>
                              </select>
                              <label class="text-label ml-2 mb-0">Min</label>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="row backgroundRow py-2 px-5">
                  <div class="py-5 d-flex flex-column fullWidth">
                    <div class="row pt-5 d-flex flex-row align-items-center">
                      <h6 class="mx-3">{{ $t("minibus.request.step.two.ending.date")}}</h6>
                      <p class="minibus-request-step2-date-slot"> {{dateTo}}</p>
                    </div>
                    <div class="row">
                      <div class="col-12 col-lg-6 jjj px-4">
                        <label for="datepicker">{{ $t("minibus.request.step.two.starting.date.date") }}<sup class="text-red">*</sup></label>
                        <d-datepicker
                          id="datepicker"
                          class="pr-1"
                          v-model="model.dateRange.to"
                          :disabledDates="disabledDatesTo"
                          placeholder="Date de fin"
                          @input="checkDates"
                          :input-class="['form-control', 'datepicker', 'py-3']"
                          :language="fr"
                          small
                        ></d-datepicker>
                      </div>
                      <div class="col-12 col-lg-6 jjj px-4 d-flex align-items-center">
                        <div>
                          <label>{{ $t("global.select.ending.time") }}</label>
                          <div class="row pl-3 pt-2">
                            <div class="d-flex align-items-center justify-content-center">
                              <select
                                id="hourEnd"
                                class="form-control mt-0"
                                v-model="model.endHour"
                                @change="changeEndHour"
                                :disabled="disabled"
                              >
                                <option v-for="(h, idx) in hours" :key="idx" :value="h">
                                  {{ h }}
                                </option>
                              </select>
                              <label class="text-label mx-2 mb-0">H:</label>
                            </div>

                            <div class="d-flex align-items-center justify-content-center">
                              <select
                                id="minuteEnd"
                                class="form-control mt-0"
                                v-model="model.endMinute"
                                @change="$emit('updateDate', model)"
                                :disabled="disabled"
                              >
                                <option v-for="(m, idx) in minutes" :key="idx" :value="m">
                                  {{ m }}
                                </option>
                              </select>
                              <label class="text-label ml-2 mb-0">Min</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import Errors from '../../error/errors';
import TimeUtils from '../../../utils/TimeUtils';
import { fr } from 'vuejs-datepicker/dist/locale';
import DateTime from '../../form/DateTime.vue';
import Long from "long";

export default {
  name: 'StepThreeMinibus',
  components: { Errors, DateTime },
  props: ['user', 'isExternalClient'],
  data() {
    return {
    model: {
        firstName: '',
        lastName: '',
        email: '',
        title: '',
        description: '',
        destination: '',
        startHour: '08',
        startMinute: '00',
        endHour: '17',
        endMinute: '00',
        dateRange: {
          from: new Date(),
          to: new Date(),
        },
      },
      errors: {},
      requiredFields: ['title', 'dateRange'],
      disabledDatesFrom: {
        to: new Date(),
      },
      fr,
      adminRef: [],
      recepRef: [],
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ],
      minutes: ['00', '10', '20', '30', '40', '50'],
    };
  },
  async created() {
    const datepickers = await document.getElementsByClassName('datepicker');
    for (let i = 0; i < datepickers.length; i++) {
      datepickers[i].style.cursor = 'pointer';
    }
  },
  computed: { 
    disabledDatesTo() {
      return {
        to: this.model.dateRange.from || new Date(),
      };
    },  
    user() {
      return this.$store.state.user.informations;
    },

    dateFrom() {
      return TimeUtils.formatFullDay(Long.fromValue(new Date(this.model.dateRange.from).getTime()));
    },

    dateTo() {
      return TimeUtils.formatFullDay(Long.fromValue(new Date(this.model.dateRange.to).getTime()));
    },
  },
  methods: {
    previous() {
      this.$emit('input', null);
    },
    checkDates() {
      if (this.model.dateRange.to < this.model.dateRange.from) {
        this.model.dateRange.to = this.model.dateRange.from;
      }
    },
    getFullDate(date, Hour, Minute) {
    let hours = parseInt(Hour) * 60 *60 * 1000 ;
    let min = parseInt(Minute) * 60 * 1000 ;
    let calculatedDate = new Date(date.toISOString().split('T')[0]).subtractHours(1).getTime() + hours + min ;
    return new Date(calculatedDate) ;
    },
    nextStep() {
      this.errors = {};
      let listOfRecep = []; 
      this.recepRef.forEach((recep) => { listOfRecep.push({groupReference: "_receptionist", status: "PENDING", userReference: recep}) });
      if (this.isExternalClient) {
        const model = {
          isExternalClient: this.isExternalClient,
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          email: this.model.email,
          title: this.model.title,
          description: this.model.description,
          destination: this.model.destination,
          userReference: this.user.reference,
          authorized: [this.user.reference],
          userFirstName: this.user.firstName ,
          userLastName: this.user.lastName ,
          answers: [{groupReference: "_super_admin", status: "PENDING", userReference: this.adminRef[0]}, ...listOfRecep],
          fromDate: this.getFullDate(this.model.dateRange.from, this.model.startHour, this.model.startMinute),
          toDate: this.getFullDate(this.model.dateRange.to, this.model.endHour, this.model.endMinute),
          status: "PENDING"
        };
          this.$emit('input', model);
      } else {
        this.$emit('input', {
          isExternalClient: this.isExternalClient,
          title: this.model.title,
          userReference: this.user.reference,
          authorized: [this.user.reference],
          description: this.model.description,
          destination: this.model.destination,
          userFirstName: this.user.firstName ,
          userLastName: this.user.lastName ,
          answers: [{groupReference: "_super_admin", status: "PENDING", userReference: this.adminRef[0]}, ...listOfRecep],
          fromDate: this.getFullDate(this.model.dateRange.from, this.model.startHour, this.model.startMinute),
          toDate: this.getFullDate(this.model.dateRange.to, this.model.endHour, this.model.endMinute),
          status: "PENDING"
        });
      }
    },
  },

  mounted() {
    this.$services.user.getUsers()
      .then((data) => {
        data.data.forEach((user) => {
          if(user.permissions[0] && user.permissions[0].groupReference == '_super_admin'){
            this.adminRef.push(user.reference);
          }
          if(user.permissions[0] && user.permissions[0].groupReference == '_receptionist'){
            this.recepRef.push(user.reference);
          }
        })
      let filteredUsers = data.data.forEach((user) => user.permissions[0]);
      }
      ).catch ((e) => console.log("error: ", e))

  }
};
</script>

<style scoped>
.card {
  position: relative;
  background-color: transparent;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
.custom-card {
  background-color: #ffffff;
}
.custom-datepicker input {
  border: none !important;
  background-color: #b6bbdd !important;
  color: #007bff !important;
  border-radius: 15px !important;
  width: 50% !important;
  text-align: center !important;
  font-weight: 600 !important;
}

/* #stepTwo-from-group_3 {
    margin-top: -25px !important;
} */

.backgroundRow:nth-child(even) {
    background-color: #f6f8ff;
}

.minibus-request-step2-select {
  height: 40px !important;
  border-radius: 8px !important;
}

.minibus-request-step2-date-slot {
  color: #4F78E1;
  font-size: 16px;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 25px;
  background-color: rgba(79, 120, 225, 0.2);
}

.minibus-request-step2-hour-slot {
  width: 100%;
  background-color: #fff;
  border: 1px solid #e1e5eb ;
  border-radius: 0.625rem;
  color: #495057;
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1.5;
  padding: 0.625rem;
}

.marginBottom {
  margin-bottom: 200px;
}

.text-red {
  color: red;
  font-size: 16px;
  font-weight: 900;
}

.fullWidth {
  width: 100% !important;
}

</style>
